import classNames from 'classnames';
import React, { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  className?: string | null;
  ellipsis?: boolean;
  onClick?: () => void;
};

const Card = ({
  children,
  className = null,
  ellipsis = false,
  onClick
}: Props) => {
  const cardClasses = classNames('card-userspace', className, {
    'card-userspace-clickable': !!onClick,
    ellipsis
  });

  return (
    <div className={cardClasses} {...(onClick ? { onClick } : {})}>
      {children}
    </div>
  );
};

export default Card;
